var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"px-6 pt-4 pb-6 add-button__container"},[_c('v-btn',_vm._g({attrs:{"block":"","color":"primary","type":_vm.type}},_vm.$listeners),[_vm._v(_vm._s(_vm.text))]),_vm._t("extension")],2)}
var staticRenderFns = []

export { render, staticRenderFns }